<template>
    <div
        class="wrapper"
    >
        <form
            class="login"
            @submit.prevent="login()"
        >
            <DCard
                padding
            >
                <h1 class="text-center">
                    {{ $t('login.heading') }}
                </h1>
                <DFormRow
                    :label="$t('login.email_label')"
                    is-required
                >
                    <DInput
                        v-model="form.email"
                        :placeholder="$t('login.email_label')"
                        add-input-classes="bg-light"
                        :is-valid="isValid('email')"
                        :invalid-feedback="errors.email"
                        maxlength="255"
                    />
                </DFormRow>
                <DFormRow
                    :label="$t('login.password_label')"
                    is-required
                >
                    <DInput
                        v-model="form.password"
                        :placeholder="$t('login.password_label')"
                        type="password"
                        add-input-classes="bg-light"
                        :is-valid="isValid('password')"
                        :invalid-feedback="errors.password"
                        maxlength="255"
                    />
                </DFormRow>
                <DFormRow label="">
                    <DButton
                        :label="$t('login.submit')"
                        color="primary"
                        class="float-right"
                        type="submit"
                        :loading="form.processing"
                        :disabled="form.processing"
                    />
                </DFormRow>
            </DCard>
        </form>
    </div>
</template>

<script>
import { useForm } from '@inertiajs/vue3'

export default {
    name: 'Index',
    props: {
        errors: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data () {
        return {
            form: useForm({
                email: null,
                password: null
            })
        }
    },
    methods: {
        login () {
            this.form.post(this.$route('login'))
        },
        isValid (field) {
            if (typeof this.errors[field] !== 'undefined') {
                return false
            }

            if (this.form[field] === null) {
                return null
            }

            return null
        }
    }
}
</script>

<style lang="scss" scoped>
.wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90vh;
    overflow: hidden;
    color: #0a111a;

    .login {
        width: 90%;
        max-width: 600px;
        margin: 0 auto;
    }
}
</style>
